import React, { useState, useEffect } from "react";
import "../styles/Documents.css";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";

import cert1 from "../assets/sertifika1.jpeg";
import cert2 from "../assets/sertifika2.jpeg";
import cert3 from "../assets/sertifika3.jpg";
import cert4 from "../assets/sertifika4.jpg";

import report1 from "../assets/Pre-purchase survey report of yact - 1.pdf";
import report2 from "../assets/Pre-purchase survey report of yact - 4.pdf";

function Documents() {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPDF, setSelectedPDF] = useState(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (
        e.key === "PrintScreen" ||
        (e.ctrlKey && e.key === "p") ||
        (e.ctrlKey && e.shiftKey && e.key === "i") ||
        e.key === "F12"
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  useEffect(() => {
    if (selectedImage || selectedPDF) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage, selectedPDF]);

  const certificates = [
    { titleKey: "documents.items.cert1", file: cert1 },
    { titleKey: "documents.items.cert2", file: cert2 },
    { titleKey: "documents.items.cert3", file: cert3 },
    { titleKey: "documents.items.cert4", file: cert4 },
  ];

  const reports = [
    { titleKey: "documents.items.report1", file: report1 },
    { titleKey: "documents.items.report2", file: report2 },
  ];

  return (
    <div className="documents" onContextMenu={(e) => e.preventDefault()}>
      <h1>{t("documents.title")}</h1>

      <h2><span>{t("documents.certificates")}</span></h2>
      <div className="docGrid certGrid">
        {certificates.map((item, i) => (
          <div
            className="docCard"
            key={i}
            onClick={() => setSelectedImage(item.file)}
          >
            <img src={item.file} alt={t(item.titleKey)} />
            <h3>{t(item.titleKey)}</h3>
            <span className="viewHint">{t("documents.view")}</span>
          </div>
        ))}
      </div>

      <h2><span>{t("documents.reports")}</span></h2>
      <div className="docGrid">
        {reports.map((item, i) => (

          <div className="docCard" key={i}>
            <FaFilePdf className="pdfIcon" />
            <h3>{t(item.titleKey)}</h3>
            <button onClick={() => setSelectedPDF(item.file)}>
              {t("documents.view")}
            </button>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="imgModal" onClick={() => setSelectedImage(null)}>
          <div className="imgModalContent" onClick={(e) => e.stopPropagation()}>
            <span className="closeBtn" onClick={() => setSelectedImage(null)}>
              ✕
            </span>
            <img
              src={selectedImage}
              alt={t("documents.certificates")}
              onContextMenu={(e) => e.preventDefault()}
              draggable={false}
            />
          </div>
        </div>
      )}

      {selectedPDF && (
        <div
          className="pdfModal"
          onClick={() => setSelectedPDF(null)}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="pdfContent" onClick={(e) => e.stopPropagation()}>
            <span className="closeBtn" onClick={() => setSelectedPDF(null)}>
              ✕
            </span>
            <iframe
              src={`${selectedPDF}#toolbar=0&navpanes=0&scrollbar=1`}
              title="PDF Preview"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Documents;